import React, { useState } from 'react';


//window.location.href = '/'
export default function Logout() {
    localStorage.clear();
    window.location.href = '/'
}